import { render } from "./scope3ActivityRecorder.vue?vue&type=template&id=69695441&ts=true"
import script from "./scope3ActivityRecorder.vue?vue&type=script&lang=ts"
export * from "./scope3ActivityRecorder.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__